import { ArrowRightIcon, LandlineIcon } from '@rsos/assets/icons';
import IntlCallbackModal from './IntlCallbackModal';
import styles from './ToolsIntlCallbackCard.module.css';
import useIntlCallback from './useIntlCallback';

/**
 * Tools-tab compact card for the International Callback feature. The entire
 * card is interactive — clicking or pressing Enter/Space opens the callback
 * modal.
 */
const ToolsIntlCallbackCard = () => {
  const { state, open, close } = useIntlCallback();

  return (
    <>
      <div
        className={styles.card}
        data-name="tools-intl-callback-card"
        onClick={open}
        role="button"
        tabIndex={0}
        aria-label="Open International Callback"
      >
        <div className={styles.row}>
          <div className={styles.info}>
            <div className={styles.titleRow}>
              <LandlineIcon
                aria-hidden
                color="primaryText"
                height={12}
                width={12}
              />
              <span
                className={styles.title}
                data-name="tools-intl-callback-card-title"
              >
                Intl. Callback
              </span>
            </div>
            <span
              className={styles.subtitle}
              data-name="tools-intl-callback-card-subtitle"
            >
              International Numbers
            </span>
          </div>
          <div
            className={styles.arrowIcon}
            data-name="tools-intl-callback-card-icon"
            aria-hidden
          >
            <ArrowRightIcon color="secondaryText" height={20} width={22} />
          </div>
        </div>
      </div>
      <IntlCallbackModal
        isOpened={state.isOpen}
        onClose={close}
        onRetry={open}
        pin={state.pin}
        bridgeNumber={state.bridgeNumber}
        callerPhoneNumber={state.callerPhoneNumber}
        isCreatingSession={state.isCreatingSession}
        error={state.error}
      />
    </>
  );
};

export default ToolsIntlCallbackCard;
